module.exports = __webpack_public_path__ + "img/background.cdb89fb5.png";